import type { Mission } from '../missions.ts'

export const fiscal: Mission = {
  id: "fiscal",
  name: "Bureau of the Fiscal Service",
  short: "Fiscal Service",
  call: "Payments",
  kind: "subagency",
  parent: "treasury",
  url: "https://fiscal.treasury.gov/",
  established: 2012,
  palette: {
    primary: "#0e3253",
    secondary: "#126b37",
    accent: "#9c9ea1",
  },
  colorSource: {
    kind: "site",
    url: "https://fiscal.treasury.gov/",
  },
  motif: "column",
  mission: {
    text: "Driving integrity and efficiency in federal financial operations.",
    url: "https://fiscal.treasury.gov/about-us",
  },
  fact: {
    text: "On October 7, 2012, Treasury Order 136-01 created the Bureau of the Fiscal Service, consolidating the Bureau of the Public Debt and the Financial Management Service.",
    url: "https://fiscal.treasury.gov/about-us",
  },
  logo: {
    file: "public/logos/fiscal.svg",
    source: "https://commons.wikimedia.org/wiki/File:Bureau_of_the_Fiscal_Service_logo.svg",
  },
  identifier: {
    about: "https://fiscal.treasury.gov/about-us",
    accessibility: "https://fiscal.treasury.gov/about-us/accessibility",
    foia: "https://fiscal.treasury.gov/about-us/foia",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    privacy: "https://fiscal.treasury.gov/about-us/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fiscal-check-writing.jpg",
        small: "/media/fiscal-check-writing-sm.jpg",
        alt: "A Treasury check-writing machine with stacks of printed checks feeding through it.",
        title: "Treasury check-writing machine, Washington, D.C., March 1937",
        creator: "Harris & Ewing, Library of Congress",
        source: "https://commons.wikimedia.org/wiki/File:Cost_$2,000,000_to_write_U.S._checks._Washington,_D.C.,_March_17._Reflecting_the_widening_range_of_federal_activity,_the_Treasury,_as_the_Nation%27s_Paymaster,_issed_35,735,746_checks_in_1936,_LCCN2016871375.jpg",
        license: "Public domain (no known restrictions)",
      },
    ],
  },
}
